import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import TeenInstantResultBody from '../../../casinoComponents/refResultModal/TeenInstantResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

/**
 * Instant Teenpatti (teen3 / teen32 / teen33) "Last Result" items in the reference markup
 * (inside .casino-video-last-results): win 1 → <span class="resulta">A  </span>,
 * win 2 → <span class="resultb"> B </span>, win 0 → "  T".
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the reference result modal.
 * Last results are refetched when the round changes (reference: getLastResults on a new mid) and every 5s.
 */
const ResultTeenInstant = ({ gameType = 'teen33', title = 'Instant Teenpatti 3.0', roundId }) => {
    const apiType = (gameType || 'teen33').toLowerCase().trim();
    const [lastResults, setLastResults] = useState([]);
    const [detailResult, setDetailResult] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const fetchLastResults = async () => {
            try {
                const response = await getLastResults(apiType);
                const res = response?.data?.data?.res;
                if (!cancelled && Array.isArray(res)) setLastResults(res);
            } catch (error) {
                console.error('Error fetching last results:', error);
            }
        };
        fetchLastResults();
        // also poll (local backend can publish a round's result a little after the new round starts)
        const interval = setInterval(fetchLastResults, 5000);
        return () => { cancelled = true; clearInterval(interval); };
    }, [apiType, roundId]);

    const handleResultClick = async (mid) => {
        if (!mid) return;
        setLoading(true);
        try {
            const response = await getDetailResults(apiType, mid.toString());
            const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
            setDetailResult(t1 || null);
            setShowModal(!!t1);
        } catch (error) {
            console.error('Error fetching detail results:', error);
        }
        setLoading(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setDetailResult(null);
    };

    return (
        <>
            {lastResults.map((r, index) => {
                const win = String(r?.win ?? '');
                return (
                    <span
                        key={r?.mid ?? index}
                        className={win === '1' ? 'resulta' : win === '2' ? 'resultb' : undefined}
                        onClick={() => handleResultClick(r?.mid)}
                    >
                        {win === '1' && 'A'}{' '}{win === '2' && 'B'}{' '}{win === '0' && 'T'}
                    </span>
                );
            })}
            {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
            <RefResultModal
                show={showModal && !loading && !!detailResult}
                onHide={handleCloseModal}
                title={`${detailResult?.ename || title} Result`}
                roundId={detailResult?.rid}
                matchTime={formatRefMatchTime(detailResult?.mtime)}
            >
                <TeenInstantResultBody t1={detailResult} />
            </RefResultModal>
        </>
    );
};

export default ResultTeenInstant;
